module.exports = __webpack_public_path__ + "img/thumb_25.df5305b7.jpg";